import styled from 'styled-components';

export const SelectedCollectItemLaboratoryContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

export const ListCollectItemLaboratoryContainer = styled.div`
  height: 100%;
  width: 100%;
`;
